const grayscaleShader = `
  precision lowp float;
  uniform sampler2D samplerVideo;
  varying vec2 vUV;
  void main(void) {
    vec4 videoTexture = texture2D(samplerVideo, vUV);
    videoTexture.rgb = vec3(dot( videoTexture.rgb, vec3(.5)));
    gl_FragColor = videoTexture;
  }`;

export default grayscaleShader;
